import { SeriesType } from '../types/enums/seriesType'
import { isPounds } from './localStorageUtils'
import { getValueSuffix } from './graphUtils'

const L100_MAX_WEIGHT_KG = 230
const P2000_MAX_WEIGHT_KG = 4000
const P2000_MIN_WEIGHT_KG = 0

export const convertToWeightScale = (weightValue: number) => {
  const isPoundsEnabled = isPounds()
  return isPoundsEnabled ? weightValue / 28.34952 : weightValue
}

export const convertFromWeightScale = (weightValue: number) => {
  const isPoundsEnabled = isPounds()
  return isPoundsEnabled ? weightValue * 28.34952 : weightValue
}

export const weightValueToDisplay = (weightValueInKg: number): string => {
  const maxDecimalPlaces = isPounds() ? 2 : 1
  const weightValue = convertToWeightScale(weightValueInKg)
  return `${parseFloat(weightValue.toFixed(maxDecimalPlaces))}${getValueSuffix(SeriesType.WEIGHT)}`
}

export const calculateWeightLoss = (startWeight: number, endWeight: number) => {
  return `${parseFloat((((startWeight - endWeight) / startWeight) * 100).toFixed(2))}%`
}

///

export const kgToPounds = (value: number): number => {
  const isPoundsEnabled = isPounds()
  return isPoundsEnabled ? value * 2.20462262185 : value
}

export const poundsToKg = (value: number): number => {
  const isPoundsEnabled = isPounds()
  return isPoundsEnabled ? value / 2.20462262185 : value
}

export const getSingleBigWeightSuffix = (): string => {
  return isPounds() ? 'lb' : 'kg'
}

export const getBigWeightSuffix = (): string => {
  return isPounds() ? 'lbs' : 'kg'
}

export const weightInputToDecimal = (weight: string | number): number => {
  return Math.round(parseFloat(`${weight}`) * 100) / 100 || 0
}

export const getP2000MinWeight = (): number => {
  return P2000_MIN_WEIGHT_KG
}

export const getP2000MaxWeight = (): number => {
  return P2000_MAX_WEIGHT_KG
}

export const getL100MaxWeight = (): number => {
  return L100_MAX_WEIGHT_KG
}
